<template>
  <div v-show="field.isVisible">
    <DocumentFieldString
      v-if="field.type == 0"
      :field.sync="field"
      :validator.sync="validator"
      :index="index"
      :disabled="disabled"
      :ctIndex="ctIndex"
      :fieldChangeSource="fieldChangeSource"
    />
    <DocumentFieldDatetimeISOCompliant
      v-if="field.type == 1 && isNewValueFormat"
      :field.sync="field"
      :validator.sync="validator"
      :index="index"
      :disabled="disabled"
      :ctIndex="ctIndex"
      :fieldChangeSource="fieldChangeSource"
    />
    <DocumentFieldDatetime
      v-else-if="field.type == 1"
      :field.sync="field"
      :validator.sync="validator"
      :index="index"
      :disabled="disabled"
      :ctIndex="ctIndex"
      :fieldChangeSource="fieldChangeSource"
    />
    <DocumentFieldNumericISOCompliant
      v-if="field.type == 2 && isNewValueFormat"
      :field.sync="field"
      :validator.sync="validator"
      :index="index"
      :disabled="disabled"
      :ctIndex="ctIndex"
      :fieldChangeSource="fieldChangeSource"
    />
    <DocumentFieldNumeric
      v-else-if="field.type == 2"
      :field.sync="field"
      :validator.sync="validator"
      :index="index"
      :disabled="disabled"
      :ctIndex="ctIndex"
      :fieldChangeSource="fieldChangeSource"
    />
    <DocumentFieldList
      :ref="listFieldKey"
      v-if="field.type >= 3"
      :field.sync="field"
      :validator.sync="validator"
      :index="index"
      :disabled="disabled"
      :ctIndex="ctIndex"
      :canAddData="canAddData"
      :fieldChangeSource="fieldChangeSource"
    />

  </div>
</template>
<script>
import DocumentFieldString from "@/components/document/documentModal/field/types/DocumentFieldString";
import DocumentFieldNumeric from "@/components/document/documentModal/field/types/DocumentFieldNumeric";
import DocumentFieldDatetime from "@/components/document/documentModal/field/types/DocumentFieldDatetime";
import DocumentFieldList from "@/components/document/documentModal/field/types/DocumentFieldList";
import DocumentFieldNumericISOCompliant from "@/components/document/documentModal/field/types/DocumentFieldNumericISOCompliant";
import DocumentFieldDatetimeISOCompliant from "./types/DocumentFieldDatetimeISOCompliant.vue";

export default {
  components: {
    DocumentFieldString,
    DocumentFieldList,
    DocumentFieldNumeric,
    DocumentFieldDatetime,
    DocumentFieldNumericISOCompliant,
    DocumentFieldDatetimeISOCompliant,
  },
  props: {
    documentId: {
      type: Number,
    },
    field: {
      type: Object,
    },
    index: {
      type: Number,
    },
    ctIndex: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
    canAddData: {
      type: Boolean,
      default: false,
    },
    isNewValueFormat: {
      type: Boolean,
      default: false,
    },
    fieldChangeSource: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      listFieldKey: "listFieldKey",
    };
  },
  computed: {
    isReadOnly() {
      return this.field.isReadOnly && this.documentId > 0;
    },
    listFieldInstance() {
      return this.$refs[this.listFieldKey];
    },
  },
  methods: {

    refreshListElements(parameters) {
      this.listFieldInstance.getListElements(parameters);
    },
  },
  watch: {
    "field.value": {
      immediate: true,
      handler(val, oldVal) {
        this.$emit("on-field-change", this.field, this.fieldChangeSource);
      },
    },
  },
};
</script>


